<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
            <div class="justify-content-star d-flex">
                <h3><strong style="color:#1A0054">Administradores</strong></h3>
            </div>
            <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                <search-input-component :search="search" @onSearch="onFilterSearch($event)"></search-input-component>
                <!-- <select @change="filtrarPorOrden($event)" name="order-filter" id="order-filter"
                    class="form-control col-sm-12 col-md-6 col-lg-auto sin-borde text-primary bg-utel-v2-secondary mx-1 py-2 my-2 rounded-8">
                    <option value="">Ordenar por</option>
                    <option value="cursosInscritos">Cursos Inscritos</option>
                    <option value="cursosAprobados">Cursos Aprobados</option>
                    <option value="cursosReprobados">Cursos Reprobados</option>
                    <option value="rutasInscritas">Rutas Inscritas</option>
                    <option value="rutasCompletadas">Rutas Completadas</option>
                    <option value="rutasReprobadas">Rutas Reprobadas</option>
                </select> -->
                <!--<div>
                    <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox" v-model="showFilters"> Mostrar Filtros</label>
                </div>-->
                <!--<div>
                    <input
                        @input="searchData($event, 'name')"
                        label=" Buscar por nombre"
                        class="searcher form-control form-search search-nomargin"
                        single-line
                        hide-details
                    ></input>
                </div>-->
                <!--<a :href="download"
                    class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descarga reporte</a>-->
                <a href="#carga_masiva_admin" class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2">Carga masiva</a>
                <a href="#agregar_admin" class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2">Agregar usuario</a>
            </div>
        </div>
        <!--<div class="searcher-container-negative mb-5">
            <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox" v-model="showFilters"> Mostrar Filtros</label>
        </div> -->

        <h4 class="mb-4"><strong>Listado de Administradores</strong></h4>
        <v-data-table 
            :headers="headersTabs" 
            :items="desserts" 
            item-key="name"
            class="elevation-1 table text-center align-middle small" 
            loading
            :loading-text="trashes ? 'Aún no tienes usuarios eliminados parcialmente' : 'Aún no tienes usuarios creados'"
            :page="page" 
            :items-per-page="itemsPerPage" 
            mobile-breakpoint="0" 
            
            :header-props="{
                sortIcon: 'fa-solid fa-up-down'
            }"
            :footer-props="{
                'items-per-page-text': 'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50],
            }"
            hide-default-footer
        >

            <!--<template v-slot:body.prepend>
                <tr v-show="showFilters">
                    <td colspan="1"></td>
                    <td><input class="form-control" @input="searchData($event)" v-model="busqueda.name" type="text" placeholder="Nombre"></td>
                    <td><input class="form-control" @input="searchData($event)" v-model="busqueda.lastname" type="text" placeholder="Apellido"></td>
                    <td><input class="form-control" @input="searchData($event)" v-model="busqueda.email" type="text" placeholder="Email"></td>
                    <td><select class="form-control" @change="searchData($event)" placeholder="Seleccione.." v-model="busqueda.rol"><option value="">Todos</option><option value="admin">Admin</option><option value="SU">SU</option></select></td>
                    <td><input class="form-control" @input="searchData($event)" v-model="busqueda.client" type="text" placeholder="Empresa"></td>
                    <td colspan="1"></td>
                </tr>
            </template>-->

            <template v-slot:item="row">
                <tr class="text-center">
                    <td>{{ row.item.id }}</td>
                    <td>{{ row.item.firstname }}</td>
                    <td>{{ row.item.lastname }}</td>
                    <td>{{ row.item.email }}</td>
                    <td>{{ row.item.role }}</td>
                    <td>{{ row.item.empresa ? row.item.empresa.name : '' }}</td>
                    <td>
                        <button type="button" class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                            alt="Editar" title="Editar" @click.prevent="showModalEditAdmin(row.item)">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                    </td>
                    <td>
                        <button type="button" class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                            alt="Eliminar este usuario" title="Eliminar este usuario"
                            @click.prevent="showModalDeleteAdmin(row.item)">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </td>
                </tr>
            </template>

            <template v-slot:footer>
                <div class="text-center pt-2">
                    <v-pagination 
                        v-model="page"
                        :length="pageCount"
                        :total-visible="6" 
                        next-icon='fas fa-angle-right'
                        prev-icon='fas fa-angle-left'
                    ></v-pagination>
                </div>
            </template>

        </v-data-table>

        <modaldelete v-if="isModalVisible" @close="closeModalDeleteAdmin" @reloadtable="reloadTableAdmin" :student="user"
            :url="url" />
        <modaleditar v-if="isModalEditVisible" @close="closeModalEditarAdmin" @reloadtable="reloadTableAdmin"
            :student="user" :url="url" :roles="roles" />
    </div>
</template>

<script>
import modaldelete from './ModalDeleteAdmin.vue';
import modaleditar from './ModalEditAdmin.vue';
export default {
    props: ["get", "headertab", "rol", "clients", "urlvalidateemail", "issuperadmin", "trashes", "download"],
    components: {
        modaldelete,
        modaleditar
    },
    data() {
        return {
            popup: '',
            search: '',
            searchTimeout: null,
            headersTabs: this.headertab,
            roles: this.rol,
            listClients: this.clients,
            url: this.get,
            desserts: [],
            edit: [],
            destroy: [],
            newUser: {
                firstname: "",
                lastname: "",
                role: '',
                client_id: '',
                email: ''
            },
            error: [],
            showFilters: false,
            busqueda: { name: "", lastname: "", email: "", client: "", rol: "" },
            
            totalItems: 0,      // total registros
            page: 1,            // página actual
            itemsPerPage: 10,   // items por página
            pageCount: 0,       // total de páginas
            loading: false,

            isModalVisible: false,
            isModalEditVisible: false,
            user: {

            }
        };
    },
    mounted() {
        this.getData();
        this.searchParam()
        //console.log(this.roles);
        //console.log(parameters);
    },
    computed: {
        /*pageCount() {
            return Math.ceil(this.desserts.length / this.itemsPerPage)
        },*/
    },
    watch:{
        reloadTable(newVal, oldVal){
            if(newVal == true){
                this.getData();
                return false;
            }
        },
        page() {
            this.getData();
        },
        itemsPerPage() {
            this.page = 1; // reinicia a la primera página
            this.getData();
        },
        reloadTable(newVal) {
            if (newVal === true) {
            this.getData();
            }
        },
        search(newVal) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
            this.page = 1; // siempre vuelve a la primera página
            this.getData();
            }, 400); // espera 400ms después de dejar de tipear
        }
    },
    methods: {
        getData() {
            this.loading = true;
            let param = "?withUsers=true&admin=true";
            if (this.trashes) param = "?admin=true&onlyTrashes=true";

            if (this.busqueda.name != "") param += `&name=${this.busqueda.name}`;
            if (this.busqueda.lastname != "") param += `&lastname=${this.busqueda.lastname}`;
            if (this.busqueda.email != "") param += `&email=${this.busqueda.email}`;
            if (this.busqueda.rol != "") param += `&rol=${this.busqueda.rol}`;
            if (this.busqueda.client != "") param += `&empresa=${this.busqueda.client}`;
            if (this.page) param += `&page=${this.page}`;
            if (this.itemsPerPage) param += `&per_page=${this.itemsPerPage}`;
            if (this.search) param += `&search=${this.search}` //  se manda al backend

            axios.get(this.url + param).then((res) => {
                this.desserts = res.data.data;
                this.totalItems = res.data.total;
                this.page = res.data.current_page;
                this.pageCount = res.data.last_page;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        searchParam() {
            let url = document.location.search
            let search = new URLSearchParams(url);
            this.popup = search.get('popup');
            console.log(this.popup);

            if (this.popup) {
                let btn = document.getElementById('newUserBtn');
                btn.click();
            }
        },
        revisarEmailUnico(event) {
            const value = event.target.value;
            let btn = document.getElementById("agregar");
            axios
                .post(this.urlvalidateemail, { "email": value })
                .then((res) => {
                    const existsEmail = res.data;
                    console.log(existsEmail);
                    if (!existsEmail) {
                        btn.setAttribute("disabled", "disabled");
                        btn.textContent = "El email registrado ya existe";
                        this.$swal("El email registrado ya existe");
                        return;
                    }

                    btn.removeAttribute("disabled", "disabled");
                    btn.textContent = "Guardar Cambios";
                })
                .catch((err) => {
                    // cancel.removeAttribute("disabled");
                    // btn.removeAttribute("disabled");
                    // btn.textContent = "Guardar proceso";
                    // this.error = err.response.data.errors;
                });
        },
        searchData(event) {
            this.getData();
        },
        cambiarVista(view) {
            //this.$emit('changeVista', view);
        },
        showModalDeleteAdmin(usr) {
            this.user = usr;
            this.isModalVisible = true;
        },
        closeModalDeleteAdmin() {
            this.isModalVisible = false;
        },
        showModalEditAdmin(usr) {
            this.user = usr;
            this.isModalEditVisible = true;
        },
        closeModalEditarAdmin() {
            this.isModalEditVisible = false;
        },
        reloadTableAdmin(valor) {
            console.log("reloadTableAdmin", valor);
            this.$emit('reloadtabletab', valor);
        },
        onFilterSearch( searchText ){
            this.search = searchText;
        }
    },
};
</script>
